var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-base"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentTemplate,{key:_vm.currentKey,tag:"component",staticClass:"cs-template"})],1),_c('cs-segment-cookie'),_c('cs-segment-modal'),_c('cs-segment-slideshow'),_c('cs-segment-print')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }